import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  Button,
  IconButton,
  CircularProgress
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Delete as DeleteIcon, ArrowUpward, ArrowDownward } from "@mui/icons-material";
import SetupStepHelp from "./setup/SetupStepHelp";

const EtapaClientesNiveis = ({
  awarenessLevels,
  setAwarenessLevels,
  isLoading,
  generateAwarenessLevels,
  company,
  hasImportedAwarenessLevels,
  setHasImportedAwarenessLevels
}) => {
  const theme = useTheme();
  const [loadingSugestao, setLoadingSugestao] = useState(false);

  // console.log("EtapaClientesNiveis")
  // useEffect(() => {
  //   console.log("useEffect")
  //   // Verifica se awarenessLevels está vazio (ou não carregado) e se sim, faz a chamada à API
  //   if (awarenessLevels.length === 0 && !loadingSugestao && !isLoading && !hasImportedAwarenessLevels) {
  //     fetchAwarenessLevels(); // Evita a chamada repetida ao API
  //   }
  // }, [awarenessLevels, isLoading, loadingSugestao, hasImportedAwarenessLevels]);

  const fetchAwarenessLevels = async () => {
    setLoadingSugestao(true);
    setHasImportedAwarenessLevels(true);
    try {
      const data = await generateAwarenessLevels(company); // Chama a API para gerar as sugestões
      setAwarenessLevels(data);
    } catch (error) {
      console.error("Erro ao gerar sugestões:", error);
    } finally {
      setLoadingSugestao(false);
    }
  };

  // Função para editar título e descrição de um nível
  const handleEditLevel = (index, field, value) => {
    const updatedLevels = [...awarenessLevels];
    updatedLevels[index][field] = value;
    setAwarenessLevels(updatedLevels);
  };

  // Função para adicionar um novo nível de consciência
  const handleAddLevel = () => {
    const newLevel = { title: "Novo Nível", description: "Descrição do novo nível" };
    setAwarenessLevels([...awarenessLevels, newLevel]);
  };

  // Função para excluir um nível de consciência
  const handleDeleteLevel = (index) => {
    const updatedLevels = awarenessLevels.filter((_, idx) => idx !== index);
    setAwarenessLevels(updatedLevels);
  };

  // Função para mover níveis de consciência
  const handleMoveLevel = (index, direction) => {
    const updatedLevels = [...awarenessLevels];
    const levelToMove = updatedLevels[index];
    updatedLevels.splice(index, 1);
    updatedLevels.splice(index + direction, 0, levelToMove);
    setAwarenessLevels(updatedLevels);
  };

  return (
    <Box sx={{ width: "100%"}}>
      <SetupStepHelp stepKey="clientsLevels" />
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.palette.primary.main }}>
        🧠 Níveis de Consciência
      </Typography>
      <Typography variant="body2" gutterBottom>
      Adicione os níveis de consciência que sua empresa irá utilizar. Você pode adicionar manualmente clicando no botão "+" ou gerar sugestões automaticamente com a IA.
      </Typography>

      <Box display="flex" gap={2} mb={2}>
        <Button
          variant="contained"
          disabled={loadingSugestao}
          onClick={fetchAwarenessLevels}
        >
          {loadingSugestao ? <CircularProgress size={24} /> : "Gerar sugestões com IA"}
        </Button>
      </Box>

      <Grid container spacing={2} mb={4}>
      {awarenessLevels.map((level, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card variant="outlined" sx={{ boxShadow: 2 }}>
            <CardContent>
              <Box display="flex" alignItems="center" mb={1}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Título"
                  value={level.title}
                  onChange={(e) => handleEditLevel(index, "title", e.target.value)}
                />
              </Box>
              <TextField
                fullWidth
                variant="outlined"
                label="Descrição"
                value={level.description}
                onChange={(e) => handleEditLevel(index, "description", e.target.value)}
              />
              <Box display="flex" justifyContent="space-between" mt={2}>
                <IconButton onClick={() => handleMoveLevel(index, -1)} disabled={index === 0}>
                  <ArrowUpward />
                </IconButton>
                <IconButton onClick={() => handleMoveLevel(index, 1)} disabled={index === awarenessLevels.length - 1}>
                  <ArrowDownward />
                </IconButton>
                <IconButton onClick={() => handleDeleteLevel(index)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
      <Grid item xs={12} sm={6} md={4} key="ADD">
          <Card variant="outlined" sx={{ boxShadow: 2, height: "100%", cursor: "pointer" }} onClick={handleAddLevel}>
              <CardContent sx={{ height: "100%" }}>
              <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ height: "100%" }} // Garantir que o Box ocupe toda a altura do Card
              >
                  <Typography variant="h2" fontWeight="bold" sx={{ color: theme.palette.primary.main }}>
                  +
                  </Typography>
              </Box>
              </CardContent>
          </Card>
          </Grid>
    </Grid>

      
    </Box>
  );
};

export default EtapaClientesNiveis;
